import React, {useEffect} from 'react'
import {useAuth} from "../../providers/AuthProvider";
import {Outlet, useNavigate, ScrollRestoration, matchRoutes} from "react-router-dom";
import Auth from "../../Auth";
import LoadingBanner from "../../components/LoadingBanner";

const AuthLoading = (props) => {

	const {auth, isLoaded, refresh, isAppropriate, appropriate} = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		if (isLoaded) {
			let redirect = Auth.intended();
			if (redirect && isAppropriate(redirect))
			{
				// console.log('NeedsTwoFactorConfirmed', Auth.NeedsTwoFactorConfirmed);
				// console.log('TwoFactorConfirmed', Auth.TwoFactorConfirmed);
				if (Auth.Intended) {
					Auth.InitIntended = Auth.Intended;

					Auth.Intended = undefined;
				}
				return navigate(redirect,{replace: true})
			}
			navigate(appropriate(),{replace: true})
		}
	}, [isLoaded]);

	if (!isLoaded) {
		return (
			<div className='container py-4 mx-auto'>
				<div className='flex flex-col justify-center'>
					<div className='mx-auto min-h-[300px] text-center'>
						<LoadingBanner/>
					</div>
				</div>
			</div>
		)
	}
	return (
        <React.Fragment>
            <Outlet/>
            <ScrollRestoration
                getKey={(location, matches) => {
                    // default behavior
                    const talentListPages = [
                        {path: '/client/browse/talent'},
                        {path: '/client/browse/teams'},
                        {path: '/client/project/bidding/:projectId/talent-pool'},
                        {path: '/client/project/bidding/:projectId/talent-pool/role/:positionId'},
                        {path: '/client/project/bidding/:projectId/shortlist'},
                    ]
                    const isTalentListPage = matchRoutes(talentListPages, location.pathname) !== null;

                    return isTalentListPage ? location.pathname : location.key;
                }}
            />
        </React.Fragment>
	)
}

export default AuthLoading;